import { render, staticRenderFns } from "./Usertalk.vue?vue&type=template&id=72cff02b&"
import script from "./Usertalk.vue?vue&type=script&lang=js&"
export * from "./Usertalk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports